import ReactDOMServer from "react-dom/server";
import { colorsPalettes } from "@similarweb/styles";
import { i18nFilter } from "app/filters/i18nFilter";
import { percentageFilter, minVisitsAbbrFilter } from "app/filters/ngFilters";
import { ChangeTooltip } from "@similarweb/ui-components";
import { TooltipContainer } from "./StyledComponents";
import tooltipContainerConfig from "pro-features/components/Chart/src/configs/tooltip/tooltipContainerConfig";

export const getChartConfig = (chartData, sitesOrder) => ({
    plotOptions: {
        venn: {
            borderColor: "white",
        },
        series: {
            cursor: "pointer",
            animation: false,
        },
    },
    series: [
        {
            data: chartData,
        },
    ],
    chart: {
        height: 325,
        backgroundColor: colorsPalettes.carbon[25],
    },
    tooltip: {
        outside: true,
        useHTML: true,
        ...tooltipContainerConfig().tooltip,
        formatter: (args) => {
            const { chart } = args;
            const { hoverPoint } = chart;
            const filteredSites = sitesOrder.filter((x) => hoverPoint.options?.sets.includes(x));
            const changeTooltipProps = {
                header: `${minVisitsAbbrFilter()(hoverPoint.options.realValue)} ${i18nFilter()(
                    "audience.overlap.venn.tooltip.uniqueVisitors.title",
                )}`,
                tableHeaders: [
                    { position: 0, displayName: i18nFilter()("common.domain") },
                    { position: 1, displayName: i18nFilter()("common.site.share") },
                ],
                tableRows: filteredSites.map((website, idx) => {
                    const currentWebsiteData = hoverPoint.series.data.find(
                        (el) => el.sets.length === 1 && el.sets[0] === website,
                    );
                    return {
                        displayName: website,
                        value: `${percentageFilter()(hoverPoint.options.realValue / currentWebsiteData.realValue, 1)}%`,
                        color: currentWebsiteData.color,
                    };
                }),
                showChangeColumn: false,
            };
            return ReactDOMServer.renderToString(
                <TooltipContainer>
                    <ChangeTooltip {...changeTooltipProps} />
                </TooltipContainer>,
            );
        },
    },
});
